import { useMutation, useQuery } from '@tanstack/react-query'
import { addInterestCategory, updateInterestCategory, updateInterestCategoryStatus, deleteInterestCategory, getInterestCategories, createInterestSubCategory, updateInterestSubCategory, updateInterestSubCategoryStatus, deleteInterestSubCategory, getInterestSubCategories } from '../api/interest'

// FAQ Category
export const useGetInterestCategories = (queryParams = '') => {
    return useQuery({
        queryKey: ['interest_categories', queryParams],
        queryFn: () => getInterestCategories(queryParams),
        enabled: !!queryParams
    });
};

export const useCreateInterestCategory = () => {
    return useMutation({
        mutationFn: addInterestCategory
    })
};

export const useUpdateInterestCategory = () => {
    return useMutation({
        mutationFn: updateInterestCategory
    })
};

export const useUpdateInterestCategoryStatus = () => {
    return useMutation({
        mutationFn: updateInterestCategoryStatus
    })
};

export const useDeleteInterestCategory = () => {
    return useMutation({
        mutationFn: deleteInterestCategory
    })
};

// FAQ Questions
export const useGetInterestSubCategories = (queryParams = '') => {
    return useQuery({
        queryKey: ['interest_subcategories', queryParams],
        queryFn: () => getInterestSubCategories(queryParams),
        enabled: !!queryParams
    });
};

export const useCreateInterestSubCategory = () => {
    return useMutation({
        mutationFn: createInterestSubCategory
    })
};

export const useUpdateInterestSubCategory = () => {
    return useMutation({
        mutationFn: updateInterestSubCategory
    })
};

export const useUpdateInterestSubCategoryStatus = () => {
    return useMutation({
        mutationFn: updateInterestSubCategoryStatus
    })
};

export const useDeleteInterestSubCategory = () => {
    return useMutation({
        mutationFn: deleteInterestSubCategory
    })
};